<script>
import 'bulma/css/bulma.css'
import Router from '@/router/index.js'
import QuestionCard from '@/components/QuestionCard'
import InfiniteLoading from 'vue-infinite-loading'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getTeamsByTeamIds } from '@/api/FirebaseTeamWrapper.js'
import { getTrees } from '@/api/FirebaseTreesWrapper.js'
import { getMyUserId, getMyUserData } from '@/api/FirebaseUserWrapper.js'
import { hasAdminRole, sortArraybyUpdatedAt } from '@/api/Utilities.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { doc, onSnapshot, getFirestore, collection, query, where, orderBy, limit } from 'firebase/firestore'
const db = getFirestore(firebaseApp)
const DOMAIN_NAME = constant.DEFAULT_DOMAIN_NAME
const analytics = getAnalytics(firebaseApp)
require('@/css/style.css')

export default {
  components: {
    QuestionCard,
    InfiniteLoading
  },
  data () {
    return {
      tabState: '',
      trees: [],
      lastTreeValue: undefined,
      loginUserId: '',
      userData: undefined,
      teams: [],
      diffTeams: [],
      title: constant.DEFAULT_DOMAIN_TITLE,
      isTeamSetup: false,
      isTreeSetup: false,
      isSetup: false,
      isCreated: false
    }
  },
  async created () {
    if (location.hostname !== DOMAIN_NAME) { console.log('searchqnq created') }
    // 初期化
    await this.init()
    // userのlistnerを作る
    const userUnsubscribe = onSnapshot(
      doc(db, 'uids', this.loginUserId),
      async (doc) => {
        const snapUser = doc.data()
        // 配列の中身の比較
        const diffTeams = snapUser.teams.filter(id => this.userData.teams.indexOf(id) === -1)
        // 差分がある場合
        if (diffTeams.length > 0) {
          this.userData = await getMyUserData()
          const teamsOrigin = await getTeamsByTeamIds(this.userData.teams)
          this.teams = sortArraybyUpdatedAt(teamsOrigin)
          this.isTeamSetup = true
          userUnsubscribe()
        }
      }
    )

    document.title = 'Search | ' + this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', 'Search | ' + this.title)
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.loginUserId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'searchqnq/Searchqnq')
    }

    if (location.hostname !== DOMAIN_NAME) { console.log('searchqnq created finished') }
  },
  watch: {
    isTeamSetup: function (val) {
      if (!this.isTeamSetup) { return }
      if (this.isSetup) { return }
      // treeのlistenrを作る
      const QUERY_NUM = 1
      const docRef = collection(db, 'treesV2')
      let q = query(docRef)
      const team = [this.teams[0].id]
      q = query(q, where('scope', 'in', team))
      q = query(q, orderBy('updatedAt', 'desc'), limit(QUERY_NUM))
      const treeUnsubscribe = onSnapshot(q, (querySnapshot) => {
        querySnapshot.forEach(async (doc) => {
          if (doc.data()) {
            this.isTreeSetup = true
            treeUnsubscribe()
          }
        })
      })
    },
    isTreeSetup: async function (val) {
      if (!this.isTreeSetup) { return }
      if (this.isSetup) { return }
      this.tabState = this.teams[0].id
      await this.getTreesData()
      this.isSetup = true
      // App.vueに初期セットアップ完了を通知
      this.$emit('isInitSetup', this.isSetup)
    },
    async $route (to, from) {
      if (to.query.team) {
        this.tabState = to.query.team
        await this.getTreesData()
        Router.push({ path: '/' })
      }
    }
  },
  beforeDestroy () {
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  methods: {
    async init () {
      this.loginUserId = await getMyUserId()
      this.userData = await getMyUserData()
      // 匿名ユーザはAboutページへ
      if (this.userData.isAnonymous) {
        Router.push({ path: '/about' })
      }
      const teamsOrigin = await getTeamsByTeamIds(this.userData.teams)
      this.teams = sortArraybyUpdatedAt(teamsOrigin)
      // teamが1つ以上存在すれば初期セットアップ完了
      if (this.teams[0]) {
        this.tabState = (this.$route.query.team) ? this.$route.query.team : this.teams[0].id
        this.isSetup = true
        // App.vueに初期セットアップ完了を通知
        this.$emit('isInitSetup', this.isSetup)
      }
      Router.push({ path: '/' })
      this.isCreated = true
    },
    async getTreesData () {
      this.lastTreeValue = undefined
      const indexOptions = {
        targetTeamId: this.tabState,
        lastTreeValue: this.lastTreeValue
      };
      [this.trees, this.lastTreeValue] = await getTrees('team', indexOptions)
      if (this.isSetup) {
        this.$refs.infiniteLoading.stateChanger.reset()
      }
    },
    change: async function (tabState) {
      // console.log(tabState)
      this.tabState = tabState
      await this.getTreesData()
    },
    getScrollingTrees: async function () {
      if (location.hostname !== DOMAIN_NAME) { console.log('scrollingTrees') }
      // console.log('scroll-lastTreeValue: ' + this.lastTreeValue)
      const indexOptions = {
        targetTeamId: this.tabState,
        lastTreeValue: this.lastTreeValue
      }
      let scrollingTrees;
      [scrollingTrees, this.lastTreeValue] = await getTrees('team', indexOptions)
      return scrollingTrees
    },
    async infiniteHandler () {
      if (location.hostname !== DOMAIN_NAME) { console.log('infiniteHandler') }

      // console.log('tree.length: ' + this.trees.length)
      const scrollingTrees = await this.getScrollingTrees()
      this.trees = this.trees.concat(scrollingTrees)

      // console.log('tree async... ' + this.trees.length)
      if (scrollingTrees.length > 0) {
        this.$refs.infiniteLoading.stateChanger.loaded()
      } else {
        console.log('tree complete!')
        this.$refs.infiniteLoading.stateChanger.complete()
      }
    }
  }
}
</script>
<style scoped>
.searchqnq {
  margin: auto;
  max-width: 1024px;
}
</style>
<template>
  <div class='searchqnq' v-if="isCreated">
    <div class="tutorial" v-if="!isSetup">
      <br>
      <span class="text has-text-link has-text-weight-bold is-size-5">ようこそ</span>
      <p>セットアップ中</p>
      <br>
      <progress class="progress is-small" max="100">15%</progress>
      <br>
    </div>
    <div class="has-team" v-else>
      <div class="tabs is-left is-small">
        <ul>
          <li v-for="team in teams" :key="team.id" v-bind:class="{'is-active': tabState === team.id}">
            <a @click="change(team.id)" >
              {{team.teamName}}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <QuestionCard
          v-for="tree in trees"
          v-bind:tree="tree"
          v-bind:key="tree.id"
        />
      </div>
      <InfiniteLoading
        ref="infiniteLoading"
        spinner="waveDots"
        @infinite="infiniteHandler">
        <span slot="no-more">No more data :)</span>
      </InfiniteLoading>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/searchqnq/Searchqnq.vue